import VueRouter from 'vue-router'
// 用异步加载的方式引入组件
const WebHome = resolve => require.ensure([], () => resolve(require('./../components/web/WebHome.vue')), 'group-index')
const WebIndex = resolve => require.ensure([], () => resolve(require('./../components/web/WebIndex.vue')), 'group-index')
const WebProduct = resolve => require.ensure([], () => resolve(require('./../components/web/WebProduct.vue')), 'group-index')
const OperWconDetail = resolve => require.ensure([], () => resolve(require('./../components/web/OperWconDetail.vue')), 'group-index')
const ZbxxDetail = resolve => require.ensure([], () => resolve(require('./../components/web/ZbxxDetail.vue')), 'group-index')
const ZbxxList = resolve => require.ensure([], () => resolve(require('./../components/web/ZbxxList.vue')), 'group-index')

export default {
  router: new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
      {
        path: '/',
        name: 'index',
        component: WebIndex,
        children: [
          {
            path: '/',
            name: 'home',
            component: WebHome
          },
          {
            path: 'product/:operMtId',
            name: 'product',
            component: WebProduct
          },
          {
            path: 'operWconDetail/:id/:operadtype',
            name: 'operWconDetail',
            component: OperWconDetail
          },
          {
            path: 'operWconDetail',
            name: 'WconDetail',
            component: OperWconDetail
          },
          {
            path: 'zbxxDetail',
            name: 'zbxxDetail',
            component: ZbxxDetail
          },
          {
            path: 'zbxx',
            name: 'zbxx',
            component: ZbxxList
          }
        ]
      }
    ]
  })
}



// WEBPACK FOOTER //
// ./src/routes/index.js